import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';


export enum WalletBalanceChangeType {
	OUTGOING_PAYMENTS = 1,
	INCOMING_PAYMENTS =  2
}


export namespace WalletBalanceChangeType {

	export function getTitle(type: WalletBalanceChangeType): string {
		return Object.keys(WalletBalanceChangeType).find(key => WalletBalanceChangeType[key] === type);
	}

}

@Pipe({
	name: 'walletChangeTypeText',
	standalone: true
})
export class WalletChangeTypeTextPipe implements PipeTransform {

	walletBalanceChangeType = WalletBalanceChangeType;
	translatedText: string;
	constructor(private translateService: TranslateService) {
	}


	transform(value: WalletBalanceChangeType): any {
		this.getTranslate(
			this.walletBalanceChangeType.getTitle(value)
		);
		return this.translatedText;
	}


	async getTranslate(text: string) {
		text = 'ENUM.WALLET_CHANGE_TYPE.' + text;
		const m = await this.translateService.get(text).subscribe(
			res => {
				this.translatedText = res;
			}
		);
	}
}





